import React from 'react';
import ReactSpinner from 'react-spinner';

const Button = ({ label, onClick, isLoading, className }) => (
  <button onClick={isLoading ? () => { } : onClick} className={`button ${className || ''}`}>
    {isLoading ? <div style={{ height: 18.4, width: 70 }}><ReactSpinner className='white' /></div> : label}
  </button>
);

export default Button;


// WEBPACK FOOTER //
// ./src/components/Form/Button.js